import React from 'react';
import { motion } from 'framer-motion';
import { Message } from '../../types/libras';

interface MessageBubbleProps {
  message: Message;
}

export const MessageBubble: React.FC<MessageBubbleProps> = ({ message }) => {
  const isPatient = message.sender === 'patient';
  const time = new Date(message.timestamp).toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <motion.div
      initial={{ opacity: 0, y: 10, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ type: 'spring', damping: 22, stiffness: 280 }}
      className={`flex ${isPatient ? 'justify-end' : 'justify-start'} mb-3`}
    >
      <div className={`flex items-end gap-2 max-w-[85%] ${isPatient ? 'flex-row-reverse' : 'flex-row'}`}>

        {/* Avatar */}
        <div
          className="w-7 h-7 rounded-xl flex items-center justify-center text-sm flex-shrink-0 mb-0.5"
          style={isPatient ? {
            background: 'linear-gradient(135deg, rgba(14,165,233,0.25), rgba(20,184,166,0.2))',
            border: '1px solid rgba(14,165,233,0.3)',
          } : {
            background: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.1)',
          }}
        >
          {isPatient ? '🤟' : '👨‍⚕️'}
        </div>

        {/* Bubble */}
        <div className="flex flex-col gap-1">
          <div
            className="px-4 py-2.5 text-sm leading-relaxed"
            data-testid={isPatient ? 'patient-message' : 'doctor-message'}
            style={isPatient ? {
              background: 'linear-gradient(135deg, #0ea5e9, #14b8a6)',
              borderRadius: '16px 4px 16px 16px',
              color: 'white',
              boxShadow: '0 4px 16px rgba(14,165,233,0.25)',
            } : {
              background: 'rgba(255,255,255,0.06)',
              border: '1px solid rgba(255,255,255,0.08)',
              borderRadius: '4px 16px 16px 16px',
              color: '#e2e8f0',
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            }}
          >
            {message.text}
          </div>
          <span
            className="text-[10px] text-slate-600 font-medium px-1"
            style={{ textAlign: isPatient ? 'right' : 'left' }}
          >
            {isPatient ? 'Paciente' : 'Médico'} · {time}
          </span>
        </div>
      </div>
    </motion.div>
  );
};
